import React from 'react'
import {getAnalysisStatus, getAnalysisStatusColor} from "../../utils/utilsTransaction"
import TimeCounter from "./TimeCounter/TimeCounter"

function TimerBox (props) {
    if(props.transaction.analysis_status === "pending" || props.transaction.analysis_status === "in_manual_analysis"){
        return (
            <TimeCounter transaction={props.transaction}/>
        )
    }
    else{
        return(
            <div className="analysisCard" style={{height:"100%", borderWidth:"1px", borderStyle:"solid", borderColor:getAnalysisStatusColor(props.transaction.analysis_status)}}>
                <div 
                    className={["normalText", "substitleSize", "bold"].join(" ")} 
                    style={{margin:"auto", color:getAnalysisStatusColor(props.transaction.analysis_status)}}
                >
                    {getAnalysisStatus(props.transaction.analysis_status)}                    
                </div>
            </div>
        )
    }
}

export default TimerBox